import { BUTLER_TAB, type ButlerTabType } from '@cart-services/constants/butler-tab'
import { Platform, type PlatformType } from '@cart-services/hooks/fp-b2b/store-map'
import { type ComponentType } from 'react'
import FileIcon from './assets/icons/file-icon.svg?react'

export const butlerTabLabelMap: Record<ButlerTabType, string> = {
  [BUTLER_TAB.FILE]: 'PDF 檔案',
  [BUTLER_TAB.CSV]: 'CSV 檔案',
  [BUTLER_TAB.PHOTO]: '照片',
}

// PHOTO 沒有對應的頁面分頁，故無 icon
export const butlerTabIconMap: Partial<Record<ButlerTabType, ComponentType>> = {
  [BUTLER_TAB.FILE]: FileIcon,
  [BUTLER_TAB.CSV]: FileIcon,
}

export interface ButlerRoutes {
  /** 下單頁路由段，接在 basePath 後 */
  entry: string
}

export const butlerRouteMap: Record<PlatformType, ButlerRoutes> = {
  [Platform.MERCHANT]: { entry: 'ai-purchase-order' },
  [Platform.STM]: { entry: 'quick-order' },
}

export const getButlerEntryPath = (basePath: string, platform: PlatformType) =>
  `${basePath}/${butlerRouteMap[platform].entry}`

export const getButlerRecommendationsPath = (basePath: string, platform: PlatformType) =>
  `${getButlerEntryPath(basePath, platform)}/recommendations`

export const getButlerCsvRecommendationsPath = (basePath: string, platform: PlatformType) =>
  `${getButlerRecommendationsPath(basePath, platform)}/csv`

export const getButlerCartPath = (basePath: string) => `${basePath}/cart`

export const CSV_MAX_ROWS = 10000
// TODO(SD-25697): 範本檔來源待 PM 定案，先指向 spec 的 CSV 範例檔
export const CSV_TEMPLATE_URL = 'https://docs.google.com/spreadsheets/d/142QX6E3sZ3or0tt7dca0M6ezRlW6Yl-hnDJ5sdsEpcI/edit?gid=0#gid=0'
